<div class="container-fluid">
  <div class="row">
    <h1 class="offset-1 col-10 text-primary">St John's Examination Timer</h1>
  </div>
  <router-outlet></router-outlet>
</div>